import { useBoolean } from 'usehooks-ts';

import { DocumentActionItem } from '@/components/Form/ActionList/DocumentActionItem';

import { useDrawerOpenTracker } from '@/context';

import { useAppSelector } from '@/hooks/redux';
import { useTranslate } from '@/hooks/useTranslate';

import {
  selectBasicInfoStatus,
  selectOperationData,
  selectOperationUser,
} from '@/redux/operation/selectors';

import {
  DocumentSection,
  DocumentStatus,
  RequiredCondition,
  RequiredDocumentSection,
} from '@/types/document';

import { getHigherStatus } from '@/utils/document';

import { AdditionalIDSelectDrawer } from '../drawers/AdditionalID/AdditionalIDSelectDrawer';

export function MinorAdditionalID() {
  const {
    value: isOpenAdditionalIDSelectDrawer,
    setTrue: openAdditionalIDSelectDrawer,
    setFalse: closeAdditionalIDSelectDrawer,
  } = useBoolean(false);

  useDrawerOpenTracker(isOpenAdditionalIDSelectDrawer);

  const { t } = useTranslate();
  const minorUser = useAppSelector(selectOperationUser);
  const { requiredDocumentSections } = useAppSelector(selectOperationData);

  const basicInfoStatus = useAppSelector(selectBasicInfoStatus);
  const isBasicInfoProcessed =
    basicInfoStatus === DocumentStatus.InReview ||
    basicInfoStatus === DocumentStatus.Approved ||
    basicInfoStatus === DocumentStatus.Rejected;

  const secondIdSection = requiredDocumentSections.find(
    section => section.type === DocumentSection.SecondID,
  );

  const secondCitizenshipSection = requiredDocumentSections.find(
    section => section.type === DocumentSection.SecondCitizenshipID,
  );

  const additionalIdSections = [
    secondIdSection,
    secondCitizenshipSection,
  ].filter(Boolean) as RequiredDocumentSection[];

  if (additionalIdSections.length === 0) return null;

  const additionalIdStatus = getHigherStatus(
    additionalIdSections
      .map(section => section.status as DocumentStatus)
      .filter(Boolean),
    RequiredCondition.And,
  );

  const isButtonDisabled = !minorUser;

  return (
    <>
      <DocumentActionItem
        title={t('moreInfo.requiredDocumentGroup.secondIDHeader.highRisk')}
        description={t('status.pending')}
        onClick={openAdditionalIDSelectDrawer}
        status={additionalIdStatus}
        enabledForAllStatuses
        disabled={!isBasicInfoProcessed}
        disabledButton={isButtonDisabled}
      />
      <AdditionalIDSelectDrawer
        open={isOpenAdditionalIDSelectDrawer}
        sections={additionalIdSections}
        clientId={minorUser?.id}
        onClose={closeAdditionalIDSelectDrawer}
      />
    </>
  );
}
